import { NumberHelper } from "../helpers/number.helper";

export class NumberFormatValueConverter {
    
    toView(value: number, maxDecimalPlaces: number = 2, culture: string, minDecimalPlaces: number = null) {
        return NumberHelper.getFormattedValue(value, culture, maxDecimalPlaces, 0, "", minDecimalPlaces);
    }
}
